export default __webpack_public_path__ + "static/media/discord.70f52aef.svg";